import React, { useContext } from 'react';

import { useDiscover } from './hooks/useDiscover.hook';
import { LayoutContext } from 'contexts/LayoutContext';
import { DiscoverHome as DiscoverHomeNative } from './DiscoverHome.screen.native';
import { DiscoverHome as DiscoverHomeWeb } from './DiscoverHome.screen.web';
import { DiscoverLanding as DiscoverLandingNative } from './DiscoverLanding.screen.native';
import { DiscoverLanding as DiscoverLandingWeb } from './DiscoverLanding.screen.web';

export const DiscoverScreen = () => {
  const discover = useDiscover();
  const layout = useContext(LayoutContext);

  if (discover.isNewAccount) {
    if (layout.isMobile) {
      return <DiscoverLandingNative openAccount={discover.openAccount} loading={discover.enableEarnLoading} />;
    }

    return <DiscoverLandingWeb openAccount={discover.openAccount} loading={discover.enableEarnLoading} />;
  }

  if (layout.isMobile) {
    return (
      <DiscoverHomeNative
        loading={discover.offersLoading}
        isNewAccount={discover.isNewAccount}
        offers={discover.offers.data?.data?.data || []}
        popularOffers={discover.offers.data?.data?.data || []}
        refresh={discover.refresh}
        openAccount={discover.openAccount}
        onSearch={discover.handleSearch}
        showAssets={discover.showAssets}
        showAssetsPoular={discover.showAssets}
      />
    );
  }

  return (
    <DiscoverHomeWeb
      loading={(discover.offersLoading || discover.popularOffersLoading) && !discover.offersData}
      offersLoading={discover.offersLoading && !discover.offers.data}
      popularOffersLoading={discover.popularOffersLoading && !discover.popularOffers.data}
      isNewAccount={discover.isNewAccount}
      offers={discover.offers.data?.data?.data || []}
      offersByCategory={discover.offersByCategory || {}}
      popularOffers={discover.popularOffers.data?.data?.data || []}
      refresh={discover.refresh}
      openAccount={discover.openAccount}
      onSearch={discover.handleSearch}
      showAssets={discover.showAssets}
      showAssetsPoular={discover.showAssetsPopular}
    />
  );
};
